import axios from "axios";

const API = process.env.REACT_APP_API_BASE;
const ADMIN_EMAILS = [
  process.env.REACT_APP_ADMIN,
  process.env.REACT_APP_ARI_ADMIN,
]
  .filter(Boolean)
  .map((email) => email.trim().toLowerCase());

let cachedContent = null;
let pendingRequest = null;

const normalizeResponse = (response) => {
  const payload = response?.data?.data || response?.data || {};
  return payload && typeof payload === "object" ? payload : {};
};

const getAll = async ({ force = false } = {}) => {
  if (!force && cachedContent) return cachedContent;
  if (!force && pendingRequest) return pendingRequest;

  pendingRequest = axios
    .get(`${API}/main-page/text`)
    .then(normalizeResponse)
    .then((content) => {
      cachedContent = content;
      return content;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
};

const saveSection = async (section, text, adminEmail) => {
  const normalizedEmail = String(adminEmail || "").trim().toLowerCase();
  if (!normalizedEmail || !ADMIN_EMAILS.includes(normalizedEmail)) {
    throw new Error("Accesul este disponibil doar administratorilor configurați.");
  }

  const response = await axios.put(
    `${API}/main-page/text/${section}`,
    { text },
    {
      headers: {
        ...(process.env.REACT_APP_TOKEN
          ? { Authorization: `Basic ${process.env.REACT_APP_TOKEN}` }
          : {}),
        "x-admin-email": normalizedEmail,
      },
    }
  );

  cachedContent = {
    ...(cachedContent || {}),
    [section]: {
      ...(cachedContent?.[section] || {}),
      ...text,
    },
  };

  return normalizeResponse(response);
};

const mainPageTextService = {
  getAll,
  saveSection,
};

export default mainPageTextService;
